import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Calendar, ArrowRight } from 'lucide-react';
import { fetchCollection } from '../../lib/cms';
import SEO from '../../components/SEO';

export default function NyhederEn() {
  const [nyhederList, setNyhederList] = useState([]);

  useEffect(() => {
    async function loadData() {
      const data = await fetchCollection('nyheder', 'en');
      setNyhederList(data);
    }
    loadData();
  }, []);

  return (
    <div className="relative pb-16 md:pb-8 bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="News & Updates"
        description="Read the latest news, product upgrades, and stories from Danshaker. Stay updated on our latest product innovations and financing options."
        path="/en/news"
        lang="en"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Header Section */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-12 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            <span>News & updates</span>
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Latest News
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            Follow the newest updates, customized machine options, and financing announcements from Danshaker.
          </p>
        </div>
      </section>

      {/* News Grid */}
      <section className="mx-auto max-w-7xl px-4 pt-12 pb-0 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {nyhederList.map((item) => (
            <article
              key={item.id}
              className="flex flex-col justify-between rounded-3xl border border-slate-200 bg-white p-8 shadow-xl transition hover:shadow-2xl hover:border-[#0E67A2]/30"
            >
              <div className="space-y-4">
                <div className="flex items-center gap-2 text-xs font-semibold text-[#0E67A2]">
                  <Calendar className="h-4 w-4" />
                  <span>{item.date}</span>
                </div>
                <h2 className="text-2xl font-bold text-slate-900 leading-tight">
                  <Link to={`/en/news/${item.slug}`} className="hover:text-[#0E67A2] transition">
                    {item.title}
                  </Link>
                </h2>
                <div
                  className="text-slate-600 line-clamp-3 text-sm leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              </div>

              <div className="pt-6 mt-6 border-t border-slate-100 flex items-center justify-between">
                <Link
                  to={`/en/news/${item.slug}`}
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#0E67A2] hover:text-[#0E67A2]/80 transition group"
                >
                  Read full article
                  <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
